var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M24 12c0-6.628-5.372-12-12-12S0 5.372 0 12c0 5.99 4.388 10.954 10.126 11.854v-8.385H7.078V12h3.048V9.356c0-3.007 1.79-4.668 4.532-4.668 1.313 0 2.686.234 2.686.234v2.952h-1.512c-1.492 0-1.956.926-1.956 1.875V12h3.327l-.531 3.468h-2.796v8.386C19.612 22.954 24 17.989 24 12",
    clipRule: "evenodd"
  })));
};
export default SvgFacebook;